import { Button, Typography } from "@earned/core";
import * as React from "react";

const SafariCookieConsent: React.FC<{ onAcceptCookie: () => void }> = ({
  onAcceptCookie,
}) => {
  return (
    <div
      data-testid="safari-cookie-consent"
      className="mx-auto flex flex-col items-center justify-center gap-8 px-10 text-center sm:max-w-[475px] sm:pt-40"
    >
      <Typography variant="title-lg" fontFamily="serif" color="primary">
        Hey Safari Users, Redirect Alert 🍪
      </Typography>
      <Typography variant="body-lg" color="primary">
        To use this feature, you’ll need to enable cookies from our partner
        site, moneyguidepro.com. Want to skip this step next time? Consider
        Chrome or another browser for a seamless experience.
      </Typography>
      <div className="w-full">
        <Button variant="primary" onClick={onAcceptCookie}>
          Accept Cookies
        </Button>
      </div>
    </div>
  );
};

export default SafariCookieConsent;
